﻿import type {RouteEditorRoute} from "../models/route-editor-route.model";
import type {RouteEditorGate} from "../models/route-editor-gate.model";
import type {Gate} from "../types/projectItems/gate.type";
import type {Route} from "../types/projectItems/route.type";

export function mapRouteToRouteEditorRoute(route: Route, gateMap: Map<string, Gate>): RouteEditorRoute {
    return {
        id: route.id,
        name: route.name,
        gateNames: route.routeGates.sort((a, b) => a.indexInRoute - b.indexInRoute).map(routeGate => gateMap.get(routeGate.gateId).name)
    };
}

export function mapGateToRouteEditorGate(gate: Gate): RouteEditorGate {
    return createRouteEditorGate(gate.id, gate.name, gate.coordinatesDto.latitude, gate.coordinatesDto.longitude);
}

export function createRouteEditorGate(id: string, name: string, latitude: number, longitude: number): RouteEditorGate {
    return {
        id: id,
        name: name,
        latitude: latitude,
        longitude: longitude
    };
}